import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import Utils from "../../utils";
import {
  getpublicPartList,
  getVehiclePartList,
} from "../../services/VehicleService";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { partInvenoryPartDelete } from "../../services/PartsInventory";
import { useTranslation } from "react-i18next";
import { tConst } from "../../utils/constantsTranslator";
import { getSettingsCompanyDetails } from "../../services/settingsServices";
import LanguageSwitcher from "../partials/LanguageSwitcher";

const PartDetailsPublic = () => {
  const state = useLocation();
  const { t } = useTranslation();

  const { uuid } = useParams();

  const [vehiclePartDetails, setVehiclePartDetails] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");

  useEffect(() => {
    if (uuid) {
      let data = {
        uuid: uuid,
      };
      getpublicPartList(data)
        .then((response) => {
          setVehiclePartDetails(response.data.data);
          //   setTotalRecords(response.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();

    let data = { id: delpart, delete_type: 1 };
    partInvenoryPartDelete(data)
      .then((response) => {
        if (uuid) {
          let data = {
            uuid: uuid,
          };

          getpublicPartList(data)
            .then((response) => {
              setVehiclePartDetails(response.data.data);
              //   setTotalRecords(response.data);
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            });
        }
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDestroyassociatePartType = (e) => {
    e.preventDefault();

    let data = { id: delpart, delete_type: 2 };
    partInvenoryPartDelete(data)
      .then((response) => {
        if (uuid) {
          let data = {
            uuid: uuid,
          };

          getpublicPartList(data)
            .then((response) => {
              setVehiclePartDetails(response.data.data);
              //   setTotalRecords(response.data);
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            });
        }
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const selectedPartColumnIds =
    settingCompanyDetails?.part_share_column_ids?.trim()
      ? settingCompanyDetails.part_share_column_ids
          .split(",")
          .map((id) => id.trim())
      : [];

  const showPartColumn = (id) => {
    return (
      selectedPartColumnIds?.length === 0 || selectedPartColumnIds.includes(id)
    );
  };

  const selectedVehicleColumnIds =
    settingCompanyDetails?.vehicle_share_column_ids?.trim()
      ? settingCompanyDetails.vehicle_share_column_ids
          .split(",")
          .map((id) => id.trim())
      : [];

  const showVehicleColumn = (id) => {
    return (
      selectedVehicleColumnIds?.length === 0 ||
      selectedVehicleColumnIds.includes(id)
    );
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 nav-item dropdown hoverDropdown">
                <LanguageSwitcher />
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="cardHeader card-header card-header-custom">
                      <p>{t("part_details")}</p>
                    </div>
                    <div className="card-body card-body-custom">
                      <div className="row justify-content-start">
                        {showPartColumn("4") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("part_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.namePartPT || "-"}
                              </address>
                            </div>
                          </div>
                        )}
                        {showPartColumn("42") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("internal_id")} :</b>{" "}
                              <address>
                                {vehiclePartDetails?.parts_internal_id || "-"}
                              </address>
                            </div>
                          </div>
                        )}
                        {showPartColumn("3") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("part_code")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.part_code || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("5") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("quantity")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.quantity || "0"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("6") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("part_price")}:</b>{" "}
                              <address>
                                € {vehiclePartDetails?.part_price || "0"}
                              </address>
                            </div>
                          </div>
                        )}
                        {showPartColumn("7") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("part_original_price")}:</b>{" "}
                              <address>
                                €{" "}
                                {vehiclePartDetails?.part_original_price || "0"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("8") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("inventory_status")}:</b>{" "}
                              <address>
                                {tConst(vehiclePartDetails?.inventory_status_name, t) ||
                                  "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("9") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("make_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.vehicle_make_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("10") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("modal_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.vehicle_model_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("11") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("year")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.initial_year || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("25") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("variant_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.vehicle_variant_name ||
                                  "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("12") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b> {t("description")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.part_description || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("13") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("condition_name")}:</b>{" "}
                              <address>
                                {tConst(vehiclePartDetails?.condition_name, t) || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("14") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("state_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.state_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("15") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("part_cost_price")}:</b>{" "}
                              <address>
                                € {vehiclePartDetails?.part_cost_price || "0"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("16") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("custom_size")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.is_custom_size || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("17") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("height")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.parts_height || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("18") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("width")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.parts_width || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("19") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("length")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.parts_length || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("20") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("weight")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.parts_weight || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("21") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("print_label")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.print_label || "-"}
                              </address>
                            </div>
                          </div>
                        )}
                        {showPartColumn("22") && (
                          <div className="col-sm-3">
                            <div className="invoice-col">
                              <b>{t("brand_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails.brand_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}
                        {showPartColumn("32") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("part_rating")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.part_rating || 0}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("23") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("vat_include")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.vat_included === 0
                                  ? "No"
                                  : "Yes" || "No"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("24") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("engine_code")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.motor_code || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("27") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("cc")}:</b>{" "}
                              <address>{vehiclePartDetails?.cc || "-"}</address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("28") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("CV")}:</b>{" "}
                              <address>{vehiclePartDetails?.cv || "-"}</address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("29") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("KW")}:</b>{" "}
                              <address>{vehiclePartDetails?.kw || "-"}</address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("30") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("Register Number dismetal")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.reg_number_dismantler ||
                                  "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("31") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("is_master_part")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.is_master_part === "1"
                                  ? "Yes"
                                  : "No" || "No"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("33") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("associate_location_part")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.associate_location === 1
                                  ? "Yes"
                                  : "No" || "No"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("34") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("vehicle_type_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.vehicle_type_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("35") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("fuel_name")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.fuel_type_name || "-"}
                              </address>
                            </div>
                          </div>
                        )}

                        {showPartColumn("36") && (
                          <div className="col-sm-6">
                            <div className="invoice-col">
                              <b>{t("motorization")}:</b>{" "}
                              <address>
                                {vehiclePartDetails?.motorization || "-"}
                              </address>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {showPartColumn("38") &&
                      vehiclePartDetails?.parts_damage?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_damage_list")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="vehicleThBg table-responsive">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <thead>
                                  <tr>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("damage_description")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("location_damage")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("type_damage")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("damage_rating")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vehiclePartDetails?.parts_damage?.map(
                                    (items) => {
                                      return (
                                        <>
                                          <tr>
                                            <td>
                                              {items?.damage_description || "-"}
                                            </td>
                                            <td>
                                              {tConst(items?.location_damage_name, t) ||
                                                "-"}
                                            </td>
                                            <td>
                                              {tConst(items?.type_damage_name, t) || "-"}
                                            </td>
                                            <td>
                                              {items?.damage_rating || "-"}
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                    {showPartColumn("43") &&
                      vehiclePartDetails?.part_qty_list?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_quantity_list")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="vehicleThBg table-responsive">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <thead>
                                  <tr>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("location_name")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vehiclePartDetails?.part_qty_list?.map(
                                    (vehiclePartDetailss) => {
                                      return (
                                        <>
                                          <tr>
                                            <td>
                                              {vehiclePartDetailss?.location_name ||
                                                "-"}
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("37") &&
                      vehiclePartDetails?.parts_reference?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_reference_list")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="vehicleThBg table-responsive">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <thead>
                                  <tr>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("condition_name")}
                                    </th>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("type_name")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("is_main")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("reference_code")}{" "}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vehiclePartDetails?.parts_reference?.map(
                                    (vehiclePartDetailss) => {
                                      return (
                                        <>
                                          <tr>
                                            <td>
                                              {tConst(
                                                vehiclePartDetailss?.condition_name,
                                                t
                                              )}
                                            </td>
                                            <td>
                                              {tConst(vehiclePartDetailss?.type_name, t)}
                                            </td>
                                            <td>
                                              {vehiclePartDetailss?.is_main}
                                            </td>
                                            <td>
                                              {
                                                vehiclePartDetailss?.reference_code
                                              }
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("39") &&
                      vehiclePartDetails?.parts_associate?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_associate")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="vehicleThBg table-responsive">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <thead>
                                  <tr>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("vehicle_type_name")}
                                    </th>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("year")}
                                    </th>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("make")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("modal")}
                                    </th>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("variant")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vehiclePartDetails?.parts_associate?.map(
                                    (items) => {
                                      return (
                                        <>
                                          <tr>
                                            <td>{items?.vehicle_type_name}</td>
                                            <td>{items?.vehicle_year}</td>
                                            <td>{items?.make_name}</td>
                                            <td>
                                              {items?.model_id === "0" ||
                                              items?.model_id === 0
                                                ? "All"
                                                : items?.model_name}
                                            </td>
                                            <td>
                                              {items?.vehicle_variant === "0" ||
                                              items?.vehicle_variant === 0
                                                ? "All"
                                                : items?.variant_name || "All"}
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                    {vehiclePartDetails?.parts_assoicate_list?.length > 0 && (
                      <>
                        <div className="card-custom-heading">
                          <p>{t("part_associate_list")}</p>
                        </div>
                        <div className="card-body card-body-custom">
                          <div className="vehicleThBg table-responsive">
                            <table className="table table-bordered rounded-table table table-striped table-hover">
                              <thead>
                                <tr>
                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("part_name")}
                                  </th>
                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("modal_name")}
                                  </th>
                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("make_name")}
                                  </th>

                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {vehiclePartDetails?.parts_assoicate_list?.map(
                                  (items) => {
                                    return (
                                      <>
                                        <tr>
                                          <td>{items?.namePartPT}</td>

                                          <td>{items?.model_name}</td>
                                          <td>{items?.make_name}</td>
                                          <td>
                                            <div className="trash-btn">
                                              <a
                                                className="delete-btn"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, items)
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </a>
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}

                    {showPartColumn("40") &&
                      vehiclePartDetails?.image_list?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_images")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              {vehiclePartDetails?.image_list?.map((image) => {
                                return (
                                  <>
                                    <div className="col-sm-3">
                                      <div className="column-img">
                                        <img src={image?.image_url} alt="" />
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("41") &&
                      vehiclePartDetails?.video_list?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_video")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              {vehiclePartDetails?.video_list?.map((items) => {
                                return (
                                  <>
                                    <div className="col-sm-3">
                                      <div className="column-img">
                                        <video
                                          src={items.video_url}
                                          width="200"
                                          controls
                                          style={{
                                            borderRadius: "5px",
                                            margin: "5px",
                                            marginLeft: "60px",
                                          }}
                                        >
                                          Your browser does not support the
                                          video tag.
                                        </video>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("40") &&
                      vehiclePartDetails?.image_list &&
                      vehiclePartDetails?.image_list.some(
                        (item) => item.damage_list.length > 0
                      ) && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_damage_images")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <tbody>
                                  {vehiclePartDetails.image_list
                                    ?.filter(
                                      (item) => item.damage_list.length > 0
                                    )
                                    .map((item, index) => (
                                      <React.Fragment key={index}>
                                        <tr>
                                          <td>
                                            <div className="col-sm-3">
                                              <div className="column-img">
                                                <img
                                                  src={item?.image_url}
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                          </td>
                                        </tr>

                                        {item?.damage_list?.map(
                                          (damage, damageIndex) => (
                                            <tr key={damageIndex}>
                                              <td
                                                colSpan="2"
                                                style={{
                                                  paddingLeft: "50px",
                                                }}
                                              >
                                                <strong>
                                                  {t("damage_description")}:
                                                </strong>{" "}
                                                {damage.damage_description}{" "}
                                                <br />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </React.Fragment>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("41") &&
                      vehiclePartDetails?.video_list &&
                      vehiclePartDetails?.video_list.some(
                        (item) => item.damage_list.length > 0
                      ) && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_damage_images")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <tbody>
                                  {vehiclePartDetails?.video_list
                                    ?.filter(
                                      (item) => item.damage_list.length > 0
                                    )
                                    .map((item, index) => (
                                      <React.Fragment key={index}>
                                        <tr>
                                          <td>
                                            <div className="col-sm-3">
                                              <div className="column-img">
                                                <video
                                                  src={item.video_url}
                                                  width="200"
                                                  controls
                                                  style={{
                                                    borderRadius: "5px",
                                                    margin: "5px",
                                                  }}
                                                >
                                                  Your browser does not support
                                                  the video tag.
                                                </video>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>

                                        {item?.damage_list?.map(
                                          (damage, damageIndex) => (
                                            <tr key={damageIndex}>
                                              <td
                                                colSpan="2"
                                                style={{
                                                  paddingLeft: "50px",
                                                }}
                                              >
                                                <strong>
                                                  {t("damage_description")}:
                                                </strong>{" "}
                                                {damage.damage_description}{" "}
                                                <br />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </React.Fragment>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                    {showPartColumn("44") &&
                      vehiclePartDetails?.parts_attribute?.length > 0 && (
                        <>
                          <>
                            <div className="card-custom-heading">
                              <p>{t("part_attribute_list")}</p>
                            </div>
                            <div className="card-body card-body-custom">
                              <div className="vehicleThBg table-responsive">
                                <table className="table table-bordered rounded-table table table-striped table-hover">
                                  <thead>
                                    <tr>
                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("label_name")}
                                      </th>

                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("attribute_value")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {vehiclePartDetails?.parts_attribute
                                      ?.filter((items) => items.is_view === 1)
                                      ?.map((items, index) => (
                                        <tr key={index}>
                                          <td>{items?.label_name || "-"}</td>
                                          <td>
                                            {items?.attribute_value || "-"}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        </>
                      )}

                    {showPartColumn("1") && (
                      <>
                        <div className="cardHeader card-header card-header-custom">
                          <p>{t("vehicle_details")}</p>
                        </div>
                        <div className="card-body card-body-custom">
                          <div className="row justify-content-start">
                            {showVehicleColumn("1") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("certificate_number")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.certificate_number || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("34") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("Internal_Id")} :</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_internal_id || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("2") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("start_date")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_process_start_date || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("3") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("registration")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.registration || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("4") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("registration_plate")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.registration_plate || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("5") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b>{t("modal_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_model || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("6") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("brand")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_brand || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("7") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("booklet_model")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_booklet_model || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("8") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_category")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_category_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("9") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("year")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_year || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("10") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_kms")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_kms || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("11") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_total_gross_weight")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_total_gross_weight || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("12") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_fuel")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.fuel_type_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("13") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b>{t("vehicle_color")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_color || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("14") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_cyllinder")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_cyllinder || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("15") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_type_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_type_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("16") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_tare")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_tare || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("17") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_eei")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_eei || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("18") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_internal_ref")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_internl_ref || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("19") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_exp_value")} :</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_exp_value || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("20") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_provenance")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_provenance || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("21") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("park_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_park_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("22") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("shelf_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.shelf_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("23") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("inventory_status")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.inventory_status === 1
                                      ? "Yes"
                                      : "No" || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("24") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("make_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.make_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("25") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("variant_name")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.variants_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("26") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("modal_ETAI")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_model_etai_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("27") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("make_ETAI")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_make_etai_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("28") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("variant_ETAI")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_variants_etai_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("29") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("year_ETAI")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_year || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("30") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vin_number")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_frame || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("31") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("Ccm3")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.ccm3 || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("32") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("HP")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details?.hp ||
                                      "-"}
                                  </address>
                                </div>
                              </div>
                            )}
                            {showVehicleColumn("33") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("power_Kw")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.power_kw || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("34") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("vehicle_doors")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.vehicle_doors_name || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("35") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("HP")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details?.HP ||
                                      "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                            {showVehicleColumn("37") && (
                              <div className="col-sm-3">
                                <div className="invoice-col">
                                  <b> {t("steering_wheel_side")}:</b>{" "}
                                  <address>
                                    {vehiclePartDetails?.vehicle_details
                                      ?.steering_wheel_side || "-"}
                                  </address>
                                </div>
                              </div>
                            )}{" "}
                          </div>
                        </div>

                        {showVehicleColumn("38") && (
                          <>
                            <div className="cardHeader card-header card-header-custom">
                              <p>{t("vehicle_extra_info")}</p>
                            </div>
                            <div className="card-body card-body-custom">
                              <div className="row justify-content-start">
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("registration_date")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.registration_date || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("special_notes")} :</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.special_notes || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("tires_front")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.tires_front || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("tires_rear")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.tires_rear || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("axel_distance")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.axel_distance || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("box_type")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.box_type || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("box_width")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.box_width || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("capacity")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.capacity || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("co2_g_km")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.co2_g_km || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("comments")} :</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.comments || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("comp_max_box")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.comp_max_box || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("max_weight_front")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.max_weight_front || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("max_weight_rear")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.max_weight_rear || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b>{t("no_of_left_doors")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.no_of_left_doors || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("no_of_rear_doors")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.no_of_rear_doors || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("no_of_right_doors")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.no_of_right_doors || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("origin_country")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.origin_country || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("origin_state")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.origin_state || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("particles_g_km")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.particles_g_km || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("power_lifting")} :</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.power_lifting || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("vehicle_provenance")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.vehicle_provenance || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("previous_registration")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.extra_info?.previous_registration ||
                                        "-"}
                                    </address>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {showVehicleColumn("41") && (
                          <>
                            <div className="cardHeader card-header card-header-custom">
                              <p>{t("vehicle_owner")}</p>
                            </div>
                            <div className="card-body card-body-custom">
                              <div className="row justify-content-start">
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b>{t("certificate_number")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.certificate_number || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_name")} :</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_name || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_address")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_address || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_bicc")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_bicc || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_cellphone")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_cellphone || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_code_cent_permanent")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info
                                        ?.owner_code_cent_permanent || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_email")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_email || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_nif")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_nif || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b> {t("owner_postal_code")}:</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_postal_code || "-"}
                                    </address>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="invoice-col">
                                    <b>{t("owner_telephone")} :</b>{" "}
                                    <address>
                                      {vehiclePartDetails?.vehicle_details
                                        ?.owner_info?.owner_telephone || "-"}
                                    </address>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {showVehicleColumn("40") &&
                          vehiclePartDetails?.vehicle_details?.vehicle_video
                            ?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>{t("vehicle_video_list")}</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="row justify-content-start">
                                  {vehiclePartDetails?.vehicle_details?.vehicle_video?.map(
                                    (items) => {
                                      return (
                                        <>
                                          <div className="col-sm-3">
                                            <div className="column-img">
                                              <video
                                                src={items.vehicle_video}
                                                width="200"
                                                controls
                                                style={{
                                                  borderRadius: "5px",
                                                  margin: "5px",
                                                  marginLeft: "60px",
                                                }}
                                              >
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                        {showVehicleColumn("39") &&
                          vehiclePartDetails?.vehicle_details?.vehicle_image
                            ?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>{t("vehicle_images")}</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="row justify-content-start">
                                  {vehiclePartDetails?.vehicle_details?.vehicle_image?.map(
                                    (image) => {
                                      return (
                                        <>
                                          <div className="col-sm-3">
                                            <div className="column-img">
                                              <img
                                                src={image?.vehicle_image}
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                        {showVehicleColumn("37") &&
                          vehiclePartDetails?.vehicle_details?.vehicle_documents
                            ?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>{t("document_list")}</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="row justify-content-start">
                                  {vehiclePartDetails?.vehicle_details?.vehicle_documents?.map(
                                    (image) => {
                                      return (
                                        <>
                                          <div className="col-sm-3">
                                            <div className="column-img">
                                              <img
                                                src={image?.document_file}
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                      </>
                    )}

                    {showPartColumn("45") &&
                      vehiclePartDetails?.parts_checklist?.length > 0 && (
                        <>
                          <>
                            <div className="card-custom-heading">
                              <p>{t("part_check_list")}</p>
                            </div>
                            <div className="card-body card-body-custom">
                              <div className="vehicleThBg table-responsive">
                                <table className="table table-bordered rounded-table table table-striped table-hover">
                                  <thead>
                                    <tr>
                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("name")}
                                      </th>

                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("description")}
                                      </th>
                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("check_list_status_name")}
                                      </th>
                                      <th className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("is_default")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {vehiclePartDetails?.parts_checklist?.map(
                                      (items, index) => (
                                        <tr key={index}>
                                          <td>{items?.name || "-"}</td>
                                          <td>{items?.description || "-"}</td>
                                          <td>
                                            {items?.check_list_status_name ||
                                              "-"}
                                          </td>
                                          <td>
                                            {items?.is_default === 1
                                              ? "Yes"
                                              : "No" || "-"}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        </>
                      )}

                    {showVehicleColumn("38") &&
                      vehiclePartDetails?.parts_check?.length > 0 && (
                        <>
                          <div className="card-custom-heading">
                            <p>{t("part_check")}</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="vehicleThBg table-responsive">
                              <table className="table table-bordered rounded-table table table-striped table-hover">
                                <thead>
                                  <tr>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </th>

                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("part_check_status_name")}
                                    </th>
                                    <th className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("part_converted_status_name")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vehiclePartDetails?.parts_check?.map(
                                    (items, index) => (
                                      <tr key={index}>
                                        <td>{items?.namePartPT || "-"}</td>
                                        <td>
                                          {items?.part_check_status_name || "-"}
                                        </td>
                                        <td>
                                          {items?.part_converted_status_name ||
                                            "-"}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_part")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{`Are you sure you want to delete?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "153px" }}
            onClick={onDestroyPartType}
          >
            {t("delete_from_inventory")} <i className="bi bi-trash3"></i>
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "197px" }}
            onClick={onDestroyassociatePartType}
          >
            {t("delete_from_associate_part")} <i className="bi bi-trash3"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PartDetailsPublic;
